
import React from "react";
import {Button, Col, Container, Row, Accordion, Card} from "react-bootstrap";
import {buildUrl} from "../service/url-builder";
import Select from "react-select";

const axios = require('axios');


class SummarySelectors extends React.Component {

    constructor(props) {
        super(props);

        this.defaultValue = props.configValue;

        this.state = {
            selectedValue : this.defaultValue == null ? "" : this.defaultValue,
            configOptions : props.configOptions,
            runContext :props.runContext,
        }
        this.parentChangeHandler = props.changedHandler;
        this.valueChanged = this.valueChanged.bind(this);
    }

    fetchReferenceData() {
        const refDataRequest = axios.get(buildUrl("/referenceData"), {
            params: {
                dataSet: "usedConfig",
                runContext:this.state.runContext
            }
        });
        axios.all([refDataRequest]).then(axios.spread((...responses) => {
            const refDataResonse = responses[0];
            let optionList = refDataResonse.data.map(option => { return { "label": option, "value":option} } );
            this.setState( { "configOptions" : optionList})
        })).catch(errors => {
            console.log("Oops something when wrong.");
        })
    }

    componentDidMount() {
        this.fetchReferenceData();
    }

    valueChanged(e) {
        this.setState( { selectedValue : e})
        this.parentChangeHandler(e);
    }
    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <Select
                            placeholder="Select Configuration"
                            name="config"
                            onChange={this.valueChanged}
                            options={this.state.configOptions}
                        />
                    </Col>
                </Row>
            </Container>
        )
    };
}
export {SummarySelectors}
